import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { team } from '../utils/mockData';

export const TeamSection = () => {
  return (
    <section id="tim" className="py-20 bg-gray-50 dark:bg-[#121212] scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Tim Profesional Kami
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Dipimpin oleh para ahli berpengalaman di bidang digital marketing
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {team.map((member) => (
            <Card
              key={member.id}
              className="border border-gray-200 dark:border-gray-800 hover:shadow-xl transition-all duration-300 bg-white dark:bg-[#0F0F0F]"
            >
              <CardContent className="p-8 text-center space-y-4">
                <div className="w-32 h-32 mx-auto rounded-full overflow-hidden bg-gray-100 dark:bg-gray-800">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1">
                    {member.name}
                  </h3>
                  <p className="text-[#D32F2F] font-medium">{member.position}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
